import FoilerBadge from '@/atoms/FoilerBadge';
import AlertTool from '@/molecules/AlertTool';
import CustomMarkdown from '@/molecules/CustomMarkdown';
import Metrics from '@/molecules/Metrics';
import TextualData, { TEXTUAL_DATA_VARIANT } from '@/molecules/TextualData';
import Tile from '@/molecules/Tile';
import { VARIANT_COLOR_ENUM } from '@/types/utils';
import { CardDetailsWithStats } from 'hooks/queries/cards/useCardsDetailsApi';
import { useTranslation } from 'next-i18next';
import Link from 'next/link';
import { CARD_TYPE_API_REF } from 'types/modifiers/references';
import { useCmsData } from 'utils/cms';

const CollectionTile = ({ card }: { card: CardDetailsWithStats }) => {
  const { t } = useTranslation();
  const { generalSettings } = useCmsData();

  return (
    <Tile title={t('informations')} withDivider>
      {card.stats?.isExclusive && (
        <AlertTool icon="fa-solid fa-circle-info" variant={VARIANT_COLOR_ENUM.INFO}>
          <CustomMarkdown className="p-0">{t('alert.exclusiveWarn')}</CustomMarkdown>
        </AlertTool>
      )}
      {card.stats?.isExclusive ? (
        <Metrics className="mt-4" icon="fa-solid fa-stars" subLine={t('exclusive-in-collection')}>
          {card.stats.numberCopyAvailable}
          <span className="title-4 text-neutral-600">/{card?.stats?.inMyCollection}</span>
        </Metrics>
      ) : (
        <Metrics icon="fa-solid fa-book-sparkles" subLine={t('in-collection')}>
          {card?.stats?.inMyCollection?.toString()}
        </Metrics>
      )}
      <div className="grid grid-cols-2 mt-6 gap-4">
        <TextualData label={t('rarity')} variant={TEXTUAL_DATA_VARIANT.smallInfo}>
          <Link className="text-system-info-400" href={`/cards?rarity[]=${card.rarity?.reference}`}>
            {card.rarity?.name}
          </Link>
        </TextualData>
        {!!(card?.cardType?.reference !== CARD_TYPE_API_REF.FOILER) && (
          <TextualData label={t('set')} variant={TEXTUAL_DATA_VARIANT.smallInfo}>
            <Link className="text-system-info-400" href={`/cards?cardSet[]=${card.cardSet?.reference}`}>
              {card.cardSet?.name}
            </Link>
          </TextualData>
        )}
        {!!(card?.cardType?.reference !== CARD_TYPE_API_REF.FOILER) && generalSettings.foiler && (
          <TextualData label={t('foil-right')} variant={TEXTUAL_DATA_VARIANT.smallInfo}>
            <div className="flex items-baseline gap-1">
              <FoilerBadge foiled={!!card?.stats?.foiled} />
              {t(card?.stats?.foiled ? 'unlocked' : 'locked')}
            </div>
          </TextualData>
        )}
      </div>
    </Tile>
  );
};

export default CollectionTile;
